import React, { FC } from "react"
import { Input } from "antd"
import { Link } from "react-router-dom"
import user from "../../../../assets/user.png"
import { SearchOutlined } from "@ant-design/icons"
import CandidateTable from "./table/CandidateTable"
import "../../../../styles/user.scss"
const CandidateManagement: FC = () => {
  return (
    <div className="user">
      <div className="user-title">
        <h1>Candidates</h1>
      </div>
      <div>
        <CandidateTable />
      </div>
    </div>
  )
}
export default CandidateManagement
